import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="24" viewBox="0 0 20 24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.5 2.392c0-.938.646-1.29 1.438-.788l14.967 9.485c.794.503.792 1.32 0 1.821L2.938 22.395c-.794.504-1.438.153-1.438-.788V2.392z" fillRule="nonzero" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" /></svg>);